import { ResourcesConfig } from 'aws-amplify'
import { Environment } from './environment.types'

export const getAwsConfig = (env: Environment): ResourcesConfig => ({
  Auth: {
    Cognito: {
      userPoolId: env.userPoolId,
      userPoolClientId: env.userPoolWebClientId,
      identityPoolId: env.identityPoolId,
    },
  },
  Analytics: {
    Pinpoint: {
      appId: env.pinpointAppId,
      region: env.awsRegion,
      bufferSize: 1000,
      flushInterval: 5000,
      flushSize: 100,
      resendLimit: 5,
    },
  },
})
